import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import { alterSiteDrawer } from '../../../../data/actions/siteActions'

export default function ChangeTable({ current = "campaigns", onSave = () => { } }) {
    const dispatch = useDispatch()
    const [table, setTable] = useState('campaigns')

    const save = () => {
        onSave(table)
        dispatch(alterSiteDrawer(false, true, 'right', null, true))
    }

    const data = [{
        label: 'Campaigns',
        value: 'campaigns',
    }, {
        label: 'Automations',
        value: 'automations',
    }, {
        label: 'Forms',
        value: 'forms',
    }, {
        label: 'Site Visits',
        value: 'sitevisits',
    }]

    return (
        <div>
            <h4 className='mar-b25'>Change Dashboard Table</h4>
            <Select outerClassName="mar-b25" data={data} label="Select Chart" value={table} onChange={e => setTable(e.currentTarget.value)} />
            <Button className="button-primary" text="Save" onClick={save} />
        </div>
    )
}